const Devider = ({ color = "gray-600", opacity = "25" }) => {
  return (
    <div className="py-2">
      <div
        style={{ height: "1px" }}
        className={`w-full bg-${color} opacity-${opacity}`}
      ></div>
    </div>
  );
};

export default Devider;
